import React, { useMemo } from 'react';

import { Box } from '@chakra-ui/react';

import paths from 'constants/paths';
import { RLLComputedProfitabilityInvestment } from 'models/types/Profitability.type';
import { PROFITABILITY_RECORD_TYPE } from 'pages/operationPortal/PlanningEvaluation/SharedComponent/constants';
import { useTranslations } from 'utils/hooks/useTranslations';

import { getData, getHeaders } from './module';
import mapProfitabilityToEdit from '../../../../EditMarketValuesReeProfitability/mapProfitabilityToEdit';
import useEditFormConfig from '../../../../useEditFormConfig';
import { useRoles } from '../../hooks';
import TableCardWithEdit from '../../TableCardWithEdit';

interface InvestmentCalculationProps {
  investment: RLLComputedProfitabilityInvestment;
  inquiryId: string;
}

export const InvestmentCalculation: React.FC<InvestmentCalculationProps> = ({
  investment,
  inquiryId,
}) => {
  const { investmentCosts } =
    paths.operation.inquiryDetails.planningEvaluation.profitabilityCalculationEdit;
  const t = useTranslations();
  const { hasRoleBankAdvisor, hasRoleRealEstateExpert } = useRoles();

  const headers = useMemo(() => getHeaders(t), [t]);
  const data = useMemo(() => getData(t, investment), [t, investment]);

  const { onEdit } = useEditFormConfig({
    pathToEdit: investmentCosts(inquiryId),
    recordType: PROFITABILITY_RECORD_TYPE.INVESTMENT_COSTS,
    editFormStructure: mapProfitabilityToEdit[PROFITABILITY_RECORD_TYPE.INVESTMENT_COSTS](),
  });

  return (
    <Box
      border="1px"
      borderColor="border.lightGrey"
      p="8"
      mb={8}
      bgColor="background.white"
      boxShadow="default"
      h="100%"
    >
      <TableCardWithEdit
        canEdit={hasRoleBankAdvisor || hasRoleRealEstateExpert}
        componentName={PROFITABILITY_RECORD_TYPE.INVESTMENT_COSTS}
        onEdit={onEdit}
        tableData={data}
        tableHeaders={headers}
        title={t(
          'pages.planningEvaluation.profitabilityCalculation.sections.investmentCalculation.title',
        )}
      />
    </Box>
  );
};
